// Sets a default for the "mask" function in jQuery – since Gravityforms
// depends on a .mask method being available on a jQuery object, and also
// chains methods from it, we need to return the jQuery object called
// so we can continue on without breaking any functionality.

if (window.jQuery) {
  jQuery.fn.mask = function() {
    return this
  }
}

// const Turbolinks = require('turbolinks')
require('./lib/navigation')
require('./lib/form')
require('./lib/lazyload')
require('./lib/gallery')
require('./lib/prevent-ghost-click')

// Turbolinks.start()
//



/** WEBPACK FOOTER **
 ** ./assets/js/main.js
 **/